import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams } from 'types';
import { KioskEventList } from 'types/generated';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseKioskEventsType {
  search: string;
  date: string;
}

function useKioskEvents({
  search,
  date,
}: IUseKioskEventsType): UseQueryResult<AxiosResponse<KioskEventList[]>> {
  const fetchKioskEvents = (): Promise<AxiosResponse<KioskEventList[]>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (search) {
      params.search = search;
    }
    if (date) {
      params.date = date;
    }

    return client.get(`events/kiosk-events/?${encodeUrlParams(params)}`);
  };

  return useQuery(['events', 'kiosk-events', search, date], fetchKioskEvents, {
    enabled: !!date,
  });
}

export default useKioskEvents;
